var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoForLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 49,
    viewBox: "0 0 104 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.11 0.0203323H-0.0445061V16.1229H52.2896C48.9148 10.9383 45.7452 5.63307 43.11 0.0203323Z",
    fill: "url(#paint0_linear_87_108653)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5156 26.8521C57.0876 23.2887 54.6421 19.735 52.2915 16.1229H-0.0444832V32.2255H63.0763C61.9068 30.4233 60.7257 28.6289 59.5156 26.8521Z",
    fill: "url(#paint1_linear_87_108653)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0763 32.2255H-0.0444832V48.328H73.2686C69.8647 42.9644 66.5363 37.5521 63.0763 32.2255Z",
    fill: "url(#paint2_linear_87_108653)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1931 0.0203323L91.2812 48.328H97.1654C100.784 48.328 103.718 45.3796 103.718 41.7422L73.3344 0.0203323H56.1931Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.72 6.60613C103.72 2.96875 100.786 0.0203094 97.1674 0.0203094H82.8413L103.718 28.7632V6.60613H103.72Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2845 0.0203323L65.0842 48.328H81.8577L46.6785 0.0203323H30.2845Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_108653",
    x1: -0.0445061,
    y1: 8.07161,
    x2: 33.214,
    y2: 8.07161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_108653",
    x1: 6.82716,
    y1: 24.1742,
    x2: 52.9247,
    y2: 24.1742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_87_108653",
    x1: 19.521,
    y1: 40.2767,
    x2: 85.4881,
    y2: 40.2767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoForLoader);
export default __webpack_public_path__ + "static/media/logo-for-loader.5637ecd13846908ef987c5535942a67b.svg";
export { ForwardRef as ReactComponent };